module.exports = __webpack_public_path__ + "static/img/SFU老师_Kid.47ecbbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_Kid.png
// module id = 1NIl
// module chunks = 0